import { render, staticRenderFns } from "./CommunityPostsCard4.vue?vue&type=template&id=b8553fa4&"
import script from "./CommunityPostsCard4.vue?vue&type=script&lang=js&"
export * from "./CommunityPostsCard4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports